import React from 'react';
import './LoginForm.less'
import { withTranslation } from 'react-i18next';
import Dialog from '../Dialog/Dialog';
import {KeycloakTalsandAPI} from '../Keycloak/KeycloakTalsandAPI';
import { HelperFunctions } from '../../../configurations/armodelviewer/HelpferFunctions';

class LoginForm extends React.Component {

    reg = null;

    static defaultProps = {
        buttonText: 'Start the Experience',
        onDiscard: function(){},
        restrictInputWithRegEx: null,
        Realmhash: window.config.host.realm,
    };

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            wantsToReset: false,
            failedCheck: false,
            failedRegExCheck: [],
            invalidFieldStyle: {border: "5px dotted red"},
            resetmail: ""
        };

        if(this.props.restrictInputWithRegEx != null){
            this.reg = new RegExp(this.props.restrictInputWithRegEx)
        }

    }

    handleChange(event, parameter) {
        let temp = this.state.failedRegExCheck;
        if(this.props.restrictInputWithRegEx != null){
            let index = this.state.failedRegExCheck.indexOf(parameter);
            let text = event.target.value;
            if(this.reg.test(text) || text === ""){
                if(index !== -1){
                    temp.splice(index, 1);
                }
            }else{
                if(index === -1){
                    temp.push(parameter);
                }
            }
            this.setState({failedRegExCheck: temp});
        }
        this.updateInput(event, parameter);
    }

    updateInput(event, parameter){
        event.persist();
        this.setState({
            [parameter]: event.target.value,
        });
    }

    handleSubmit(event) {
        const { t } = this.props;
        event.preventDefault();

        if (!this.loggedIn && !this.state.wantsToReset) {
            this.loggedIn = true;
            const username = this.state.username;
            const password = this.state.password;
            this.props.onLogin(username, password).then((res) => {
                this.props.onStart(username);
            }).catch((err) => {
                this.setState({failedCheck: true})
                this.loggedIn = false
            });
        }
        else if (!this.loggedIn)
        {
            Dialog.Alert({
                title: t('ResetPassword'),
                description: t('ResetPasswordSure'),
                options: [
                    {label: t('Reset'), className:"dangerConfirm"},
                    {label: t('Cancel'), className:""},
                ],
                panelOptions: {className: "vithrough"},
            }).then((optionChosen) => {
                if (optionChosen === 0) {
                        KeycloakTalsandAPI.ResetPassword(this.state.resetmail, this.props.Realmhash)
                        .then(() => {
                            this.setState({wantsToReset: false, resetmail: ""});
                            Dialog.Alert({
                                title: t('ResetPassword'),
                                description: t('ResetMailMessage'),
                                options: [
                                    {label: t('OK'), className:""},
                                ],
                                panelOptions: {className: "vithrough oneButtonDialog"},
                            })
                        }).catch((err) => {
                            Dialog.Alert({
                                title: t('SomethingWrong'),
                                description: err.Code === 404 ? t('EmailNotFound') : HelperFunctions.getHTTPStatusCodeErrorMessage(err.Code),
                                options: [
                                    {label: "OK", className:""},
                                    ],
                                panelOptions: {className: "vithrough oneButtonDialog"},
                        })
                    })
                }
            })
        }
    }

    close(event, self) {
        /*
        event.preventDefault();
        this.props.onDiscard();
        self.setState({ show: false });*/
    }

    render() {
        const { t } = this.props;
        return (
            <form className="login" onSubmit={(e) => { e.preventDefault(); this.handleSubmit(e)}}>
                <div className="login_form_wrapper">
                    <div className="login_header">
                        <span className="login_circle"></span>
                        <label className="login_title">{ this.state.wantsToReset ? t('ResetPassword') : t('Login')}</label>
                    </div>
                    {
                        !this.state.wantsToReset &&
                        <input
                        style = {this.state.failedRegExCheck.indexOf("username") !== -1 ? this.state.invalidFieldStyle : null}
                        type="text"
                        id="username"
                        name="username"
                        required
                        placeholder= {t('Username')}
                        value={this.state.username}
                        onChange={(e) => this.handleChange(e, 'username')}
                        />

                    }
                    {
                        !this.state.wantsToReset &&
                        <input
                        style = {this.state.failedRegExCheck.indexOf("password") !== -1 ? this.state.invalidFieldStyle : null}
                        type="password"
                        id="password"
                        name="password"
                        required
                        placeholder= {t('Password')}
                        value={this.state.password}
                        onChange={(e) => this.handleChange(e, 'password')}
                    />
                    }
                    {
                        this.state.wantsToReset &&
                        <input
                        style = {this.state.failedRegExCheck.indexOf("username") !== -1 ? this.state.invalidFieldStyle : null}
                        type="text"
                        id="resetmail"
                        name="resetmail"
                        required
                        placeholder= {"EMail"}
                        value={this.state.resetmail}
                        onChange={(e) => this.handleChange(e, 'resetmail')}
                        />

                    }
                    {
                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                        <a href="#" onClick={() => this.setState({failedCheck: false, wantsToReset: !this.state.wantsToReset})}>{ this.state.wantsToReset ? t('BackToLogin') : t('ForgotPw')}</a>
                    }
                    <div style={{display: this.state.failedCheck || this.state.failedRegExCheck.length !== 0 ? 'block' : 'none'}}>
                        <div style={{foreground: "#ff0000ff"}}>
                            {this.state.failedCheck ? t('LoginFailed') : null}
                            {this.props.restrictInputWithRegEx != null && this.state.failedCheck ?  <br/> : null}
                            {this.state.failedRegExCheck.length !== 0 ? "Illegal character spotted in one of the fields." : null}
                        </div>
                    </div>
                    <button className='login-button armodelviewer_button' type="submit" >
                        { this.state.wantsToReset ? t('ResetPassword') : t('Login')}
                    </button>
                    <div className="hr_line"></div>

                        <label>{t('NotRegistered')}</label><a href="mailto:contact@vithrough.com">contact@vithrough.com</a>
                    {
                        /*

                        <button className='login-button armodelviewer_button' type="submit" >
                                {t('Register')}
                        </button>
                        */
                    }

                </div>
            </form>
        );
    }
}

export default withTranslation()(LoginForm);
